/* eslint-disable */
/**
 * v-mcard —— Element UI <el-table> 的手机端卡片化指令
 *
 * el-table 的表头是独立的 DOM，CSS 无法直接取到列名，
 * 所以这里在渲染后把表头文案写进每个单元格的 data-label，
 * 再由 styles/mobile.less 的 .m-eltable 规则把每一行渲染成卡片。
 *
 * 用法：<el-table v-mcard :data="list"> ... </el-table>
 * PC 端不加任何 class，表现完全不变。
 */
import { MOBILE_MAX_WIDTH } from '@/libs/mobile';

function decorate(el) {
    if (!el || !el.querySelectorAll) return;

    if (window.innerWidth > MOBILE_MAX_WIDTH) {
        el.classList.remove('m-eltable');
        return;
    }
    el.classList.add('m-eltable');

    // 取最后一行表头（存在多级表头时取叶子列）
    const headRows = el.querySelectorAll('.el-table__header-wrapper thead tr');
    if (!headRows.length) return;
    const ths = headRows[headRows.length - 1].querySelectorAll('th');
    const labels = [];
    for (let i = 0; i < ths.length; i++) {
        labels.push((ths[i].innerText || '').trim());
    }

    const rows = el.querySelectorAll('.el-table__body-wrapper tbody tr');
    for (let r = 0; r < rows.length; r++) {
        const tds = rows[r].children;
        for (let c = 0; c < tds.length; c++) {
            const label = labels[c] || '';
            if (label) {
                tds[c].setAttribute('data-label', label);
                tds[c].classList.remove('is-nolabel');
            } else {
                tds[c].removeAttribute('data-label');
                tds[c].classList.add('is-nolabel');
            }
        }
    }
}

function schedule(el) {
    // 等 el-table 内部渲染（含固定列同步）完成
    setTimeout(function () {
        decorate(el);
    }, 0);
    setTimeout(function () {
        decorate(el);
    }, 300);
}

export default {
    install(Vue) {
        Vue.directive('mcard', {
            inserted(el) {
                schedule(el);
                el.__mcardResize = function () {
                    schedule(el);
                };
                window.addEventListener('resize', el.__mcardResize);
            },
            componentUpdated(el) {
                schedule(el);
            },
            unbind(el) {
                if (el.__mcardResize) {
                    window.removeEventListener('resize', el.__mcardResize);
                    delete el.__mcardResize;
                }
            },
        });
    },
};
